import React from 'react';
import styles from './Input.module.css';

export default function Input({
  className = '',
  label,
  error,
  id,
  as: Tag = 'input',
  ...rest
}) {
  const inputId = id || (typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '-') : undefined);
  return (
    <div className={`${styles.field} ${className}`}>
      {label && <label htmlFor={inputId} className={styles.label}>{label}</label>}
      <Tag id={inputId} className={`${styles.input} ${error ? styles.error : ''}`} {...rest} />
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
}
